import { DefaultAPIInstance } from "@/api";

const assistant_category_url = 'helper/category/';
const question_list_url = 'helper/category/answer/';
const get_answer_url = 'helper/question/';
const submit_question_url = 'helper/answer/';
const request_url = 'helper/order/';

export const AssistantAPI = {
    getCategory(lang) {
        return DefaultAPIInstance.get(assistant_category_url, {params: {language: lang}})
    },
    getQuestion(categoryId) {
        return DefaultAPIInstance.get(question_list_url+categoryId+"/")
    },
    getSubCategory(categoryId) {
        return DefaultAPIInstance.get(assistant_category_url+categoryId+"/")
    },
    getAnswer(questionId) {
        return DefaultAPIInstance.get(get_answer_url+questionId+"/")
    },
    submitQuestion(question) {
        return DefaultAPIInstance.post(submit_question_url, question)
    },
    requestCall(userData) {
        return DefaultAPIInstance.post(request_url, userData)
    }
}
